import { createAction } from "@reduxjs/toolkit";
import {
  getNotificationActionType,
  getNotificationCountActionType,
  getPortionNotificationActionType,
  hideNotificationActionType,
  newNotificationReceivedActionTypes,
  notificationReceiveCountActionType,
  readNotificationsActionType,
} from "./actionTypes";

export const notificationReceive = createAction(
  notificationReceiveCountActionType,
  (payload) => ({ payload }),
);

export const getNotification = createAction(
  getNotificationActionType.request,
  (payload) => ({
    payload,
  }),
);

export const getNotificationSuccess = createAction(
  getNotificationActionType.success,
  (payload) => ({
    payload,
  }),
);

export const getNotificationFailure = createAction(
  getNotificationActionType.failure,
  (error) => ({
    payload: error,
  }),
);

export const getNotificationPortion = createAction(
  getPortionNotificationActionType.request,
  (payload) => ({
    payload,
  }),
);

export const getNotificationPortionSuccess = createAction(
  getPortionNotificationActionType.success,
  (payload) => ({
    payload,
  }),
);

export const getNotificationPortionFailure = createAction(
  getPortionNotificationActionType.failure,
  (error) => ({
    payload: error,
  }),
);

export const getNotificationCount = createAction(
  getNotificationCountActionType.request,
  (payload) => ({
    payload,
  }),
);

export const getNotificationCountSuccess = createAction(
  getNotificationCountActionType.success,
  (payload) => ({
    payload,
  }),
);

export const getNotificationCountFailure = createAction(
  getNotificationCountActionType.failure,
  (error) => ({
    payload: error,
  }),
);

export const hideNotification = createAction(
  hideNotificationActionType.request,
  (payload) => ({
    payload,
  }),
);

export const hideNotificationSuccess = createAction(
  hideNotificationActionType.success,
  (payload) => ({
    payload,
  }),
);

export const hideNotificationFailure = createAction(
  hideNotificationActionType.failure,
  (error) => ({
    payload: error,
  }),
);

export const readNotifications = createAction(
  readNotificationsActionType.request,
  (payload) => ({
    payload,
  }),
);

export const readNotificationsSuccess = createAction(
  readNotificationsActionType.success,
  (payload) => ({
    payload,
  }),
);

export const readNotificationsFailure = createAction(
  readNotificationsActionType.failure,
  (error) => ({
    payload: error,
  }),
);

export const newNotificationReceivedSuccess = createAction(
  newNotificationReceivedActionTypes.success,
);
